import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <FeaturesSection />
        <ContactSection />
        <MediaSection />
        <IndexSection />
        <RankingSection />
        <AboutSection />
        <CardsSection />
        <TopicsSection />
        <CarouselSection />
        <AppSection />
        <FaqSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}